import { NgModule } from '@angular/core';

import { YoutubeCategoryService } from '../services/sapi/youtube-category.service';
import { YoutubeCategoryAdapter } from '../shared/models/sapi/youtube-category.model';

import { AdunitStatsService } from '../services/sapi/adunit-stats.service';
import { AdunitStatsAdapter } from '../shared/models/sapi/adunit-stats.model';

@NgModule({
	providers: [
		AdunitStatsService,
		AdunitStatsAdapter,
		YoutubeCategoryService,
		YoutubeCategoryAdapter,
	],
})

export class SapiModule {}
